import * as dateFnsCompat from 'utils/date-fns-compat';
import fp from 'lodash/fp';
import React, { useState, useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { lifecycle, withHandlers, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { dateFormats, routes } from '../../../../constants';
import { adminActions } from '../../../../state/modules/admin';
import { GeneralTable, LoadingButton, SelectFormField } from '../../../components';

const sortOrderOptions = [
  {
    label: 'Latest to oldest',
    value: 'date,desc'
  },
  {
    label: 'Oldest to latest',
    value: 'date,asc'
  }
];

const AdminTaskGroupTable = ({
  taskGroups,
  loadMore,
  loading,
  hasMoreToLoad,
  filter,
  onFilterChange,
}) => {
  const columns = [
    {
      key: 'name',
      name: 'Name'
    },
    {
      key: 'date',
      name: 'Date'
    },
    {
      key: 'createdBy',
      name: 'CreatedBy'
    },
    {
      key: 'details',
      name: 'Details'
    },
    {
      key: 'status',
      name: 'Status'
    },
    {
      key: 'options',
      name: 'Options'
    }
  ]

  const rows = fp.map(
    ({ id, name, description, date, pending, completed, failed, confirmed, admin }) => {
      return {
        name: {
          value: name
        },
        date: {
          value: <div className='nowrap'>{dateFnsCompat.format(new Date(date), dateFormats.ShortDate)}</div>
        },
        createdBy: {
          value: fp.get('email')(admin)
        },
        details: {
          value: <div>{`${description}`}</div>
        },
        status: {
          value: <div>
            <div>{`P(${pending}) I(${completed}) F(${failed}) S(${confirmed})`}</div>
          </div>
        },
        options: {
          value: <div>
            <LinkContainer to={routes.adminPortal.adminTaskGroupDetails(id)}>
              <Button bsStyle='plain'>
                Details
              </Button>
            </LinkContainer>
          </div>
        }
      }
    }
  )(taskGroups)

  const defaultSort = 'date,desc';

  const [sort, setSort] = useState(defaultSort);

  useEffect(() => {
    onFilterChange({
      ...filter,
      skip: 0,
      sort,
    });
  }, [sort]);

  return <div className='admin-task-group-table'>
    <Row className='no-gutter'>
      <Col md={2} sm={12}>
        <SelectFormField
          id='admin-task-group-sorting-select'
          label='Sort'
          onChange={(e) => setSort(e.target.value)}
          emptyOption={false}
          required
          value={sort}
        >
          {
            sortOrderOptions.map((option, index) => (
              <option key={`sort-order-option-${index}`} value={option.value}>
                {option.label}
              </option>
            ))
          }
        </SelectFormField>
      </Col>
    </Row>
    <GeneralTable className='admin-task-group-table' rows={rows} columns={columns} />
    <Row className='no-gutter'>
      <Col>
        {
          hasMoreToLoad ?
            <LoadingButton text='Load More +' onClick={loadMore} loading={loading} /> :
            null
        }
      </Col>
    </Row>
  </div>
}

const mapStateToProps = (state) => ({
  taskGroupQueryResult: state.admin.adminTaskGroups,
  loading: state.admin.isFetchingTaskGroup
})
const mapDispatchToProps = (dispatch) => ({
  getTaskGroups: bindActionCreators(adminActions.admin.queryAdminTaskGroups, dispatch),
  loadMoreTaskGroups: bindActionCreators(adminActions.admin.loadMoreAdminTaskGroups, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ taskGroupQueryResult }) => {
      const taskGroups = taskGroupQueryResult ? taskGroupQueryResult.result : []
      const hits = fp.getOr(0)('hits')(taskGroupQueryResult)
      const hasMoreToLoad = taskGroups.length < hits
      return {
        taskGroups,
        hasMoreToLoad
      }
    }
  ),
  withStateHandlers(
    {
      filter: {
        skip: 0,
        take: 6,
        sort: 'date,desc'
      }
    },
    {
      onFilterChange: ({ filter }) => (updatedFilter) => {
        const {
          status
        } = updatedFilter
        const newFilter = {
          ...filter,
          ...updatedFilter,
          status: fp.first(status)
        }
        return { filter: newFilter }
      }
    }
  ),
  withHandlers({
    loadMore: ({ loadMoreTaskGroups, filter, taskGroups }) => () => {
      loadMoreTaskGroups({
        ...filter,
        skip: taskGroups.length
      })
    }
  }),
  lifecycle({
    componentDidMount() {
      const {
        getTaskGroups,
        filter
      } = this.props

      getTaskGroups(filter)
    },
    componentDidUpdate(prevProps) {
      const {
        getTaskGroups,
        filter,
      } = this.props

      if (!fp.isEqual(filter)(prevProps.filter)) {
        getTaskGroups(filter)
      }
    }
  })
)(AdminTaskGroupTable)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/admin-task-portal/admin-task-group-table.js